import { Link } from "react-router-dom";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { TbHealthRecognition, TbSteam } from "react-icons/tb";
import Colors from "../../utils/colors";
import { FaPeopleGroup } from "react-icons/fa6";
import { GiHealthNormal } from "react-icons/gi";


const list = [
    {name:"Finance teams", description:"Finance teams across different industries simplify their operations by leveraging the business tools on MonyTrack Business.", Icon:TbSteam, link:"/business/use-cases/finance-teams"},
    {name:"Startups", description:"Building a startup is hard. Startup founders can leverage the tools on MonyTrack Business for their financial operations long before they are able to hire finance teams.", Icon:FaPeopleGroup, link:"/business/use-cases/startups"},
    {name:"Healthcare", description:"By leveraging MonyTrack Business, Healthcare finance teams simplify their operations, manage account receivables better and streamline their supply chain processes.", Icon:GiHealthNormal, link:"/business/use-cases/healthcare"},
    {name:"Nonprofits", description:"By leveraging MonyTrack Business, Nonprofits are able to isolate donor funds by creating business account for each donor and properly accounting for every fund.", Icon:TbHealthRecognition, link:"/business/use-cases/nonprofits"},
]


const faq_list = [
    {
        q:"What is MonyTrack Business and what does it offer?",  
        a:"MonyTrack Business is a secure platform for finance teams to manage and streamline their financial operations. MonyTrack Business provide simple tools for creating and managing business accounts, virtual USD cards, Invoicing, global USD payments, collections, approval based business payments, expense management, etc. "
    },
    {
        q:"Is MonyTrack Business the right financial management platform for my business?",  
        a:"Yes. MonyTrack Business is a great fit for most small and medium scale enterprises. For big enterprises, MonyTrack Business provides additional support and custom solutions to meet required specifications."
    },
    {
        q:"Is MonyTrack Business expensive? Can I afford it?",  
        a:"No. MonyTrack Business provides its services at affordable rates. Most of our fees are transaction fees. Our pricing is fair and transparent. For high volume businesses, we offer discount. Please contact our sales team at sales@monytrack.com"
    },
    {
        q:"How do I get started on MonyTrack Business?",  
        a:"Starting on MonyTrack Business is straight-forward. Click on the 'Try if for free' button at the top of the page and register your business on the platform. Then submit your business registration documents for our team to review your profile and complete necessary KYC compliance checks."
    },
    {
        q:"How long does it take to activate my MonyTrack Business profile?",  
        a:"Compliance review typically takes 2 business days if you have submitted all required documentations. Your profile will be activated once your compliance review is complete."
    },
    {
        q:"What documentation is required to activate my business' profile on MonyTrack Business?",  
        a:"The compliance review will require you to upload your business registration documents, applicable operating licenses and KYC documents of director(s) or beneficial owners in your company. For additional assistance, please contact our support desk at support@monytrack.com"
    },
    {
        q:"Is customer support always available to attend to me when required?",  
        a:"Yes. Our dedicated team is always available to provide support. You can use the in app chat box to contact our customer support desk or reach via email at support@monytrack.com"
    },
]



function HomeInd(){

return(
<>
    <div className="row no-margin" >
        <div className="col-md-5 no-padding">
            <div style={{padding:"4rem 2rem", backgroundColor:'#f6f7f8', height:"100%"}}>
                <div style={{width:"fit-content", backgroundColor:Colors.primary3, borderRadius:"5px", padding:"8px 1.5rem", fontSize:"1.2rem", fontWeight:'bold'}}>Industries:</div>
                <div className="card-title" style={{textAlign:"left", marginTop:"8px", lineHeight:1.1, marginLeft:'0px'}}>
                    How MonyTrack Business transforms businesses like yours.
                </div>
                <p style={{marginTop:"10px", fontSize:"1rem"}}>
                    Finance teams across different industries rely on MonyTrack Business to simplify their financial operations, minimize fraud and save time and money.
                </p>
                <div>
                    <Link to={'mailto:sales@monytrack.com?subject=Schedule a demo for MonyTrack Business&body=Hello MonyTrack Team,%0D%0A %0D%0A...'}  style={{color:Colors.primary, textDecoration:'underline', fontWeight:500, fontSize:"1rem"}}>Book a free demo or talk to a product specialist to discover how MonyTrack Business can transform your business today.</Link>
                </div>
            </div>
        </div>
        <div className="col-md-7 no-padding" style={{backgroundColor:Colors.primary}}>
            <div style={{padding:"2rem"}}>
            {list?.map((L, i)=>
                <Link className="ind-box" key={i} to={L.link}>
                    <div className="flex-center ind-icon" style={{width:'50px', height:"50px",  borderRadius:"50%", marginRight:"10px",}}>
                        <L.Icon color='inherit' size={25} />
                    </div>
                    <div style={{display:"inline-block", width:"calc( 100% - 65px)"}}>
                        <div style={{fontSize:"1.05rem", fontWeight:500}}> {L?.name} </div>
                        <div style={{fontSize:".85rem"}}> {L?.description} </div>
                    </div>
                </Link>
            )}
            </div>
        </div>
    </div>
    <div className="flex-center">
        <div className="col-lg-8" style={{padding:"4rem 2rem"}}>
            <div className="section-title" style={{textAlign:"center"}}>FAQs</div>
            <div style={{textAlign:"center", color:Colors.black1, margin:"5px 0px"}}>Some freequently asked questions. For additional enquiry, please <Link style={{color:Colors.primary, textDecoration:"underline", marginLeft:"4px"}} to={"mailto:support@monytrack.com?subject=Enquiry&body=Hello MonyTrack Team,%0D%0A %0D%0A..."}>contact support</Link>
            </div>
            <br />
            <Accordion multiple>
                {faq_list.map((f, i)=>
                    <AccordionTab key={i} header={f.q}>
                         <p className="m-0">{f.a}</p>
                    </AccordionTab>
                )}
            </Accordion>
        </div>
    </div>
    <style>{`
    .p-highlight .p-accordion-header-link, .p-accordion-header-link {background-color:#f6f7f8 }
    `}</style>
</>
)
}
export default HomeInd;